import { render, staticRenderFns } from "./ListOfClients.vue?vue&type=template&id=39a4e3ac&scoped=true"
import script from "./ListOfClients.vue?vue&type=script&lang=js"
export * from "./ListOfClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4e3ac",
  null
  
)

export default component.exports